"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = void 0;
const react_1 = __importDefault(require("react"));
const hooks_1 = require("../../hooks");
const components_1 = require("../../components");
const Search = (props) => {
    var _a;
    const searchHook = (0, hooks_1.useSearch)();
    const RenderComponent = (_a = props.render) !== null && _a !== void 0 ? _a : components_1.ExampleSearch;
    return react_1.default.createElement(RenderComponent, Object.assign({}, searchHook));
};
exports.Search = Search;
//# sourceMappingURL=Search.js.map